import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Navigate, useNavigate } from "react-router-dom";
import DataOrcamentoTable from "../../components/data-budget-table.js/data-budget-tables";
import { Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

import NewMiniDrawer from "../../components/navMenu/menu-nav";
require("firebase/auth");

function BudgetList() {
  const navigate = useNavigate();
  const [carregando, setCarregando] = useState(0);
  const [cleanFilters, setCleanFilters] = useState(false);
  const [openFilters, setOpenFilters] = useState(false);

  const userLogado = useSelector((state) => state.usuarioLogado);

  useEffect(() => {
    if (userLogado > 0) {
      return;
    }
    else {
      <Navigate to='/login' />
    }
  }, [carregando]);

  return (
    <>
      {useSelector((state) => state.usuarioLogado) > 0 ? (
        <NewMiniDrawer
          divOpen={
            <div className="freight-content">
              <div className="container" style={{ marginLeft: 0, marginRight: 0, height: 'auto' }}>
                <div className="row">
                  <div className="col-5">
                    <h3>{"Listagem de Or\u00e7amento"}</h3>
                  </div>
                  <div className="col-4"></div>
                  <div
                    className="col-1"
                  >
                    <Button
                      type="primary"
                      icon={<PlusOutlined />}
                      onClick={() => navigate("/budget")}
                      id="ButtonHover"
                    >
                      Novo
                    </Button>
                  </div>
                  <div 
                    style={{ marginLeft: "-1.3%" }} 
                    className="col-1"
                  >
                    <Button
                      type="primary"
                      onClick={() => setCleanFilters(!cleanFilters)}
                      className="btn-limpar-filtros"
                    >
                      Limpar Filtros
                    </Button>
                  </div>
                  <div 
                    style={{ marginLeft: "1%" }} 
                    className="col-1"
                  >
                    <Button onClick={() => setOpenFilters(!openFilters)}>
                      Filtros Salvos
                    </Button>
                  </div>
                </div>
                <br></br>
                <br></br>
              </div>
              {carregando ? (
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              ) : (
                <DataOrcamentoTable cleanFilter={cleanFilters} openFilter={openFilters} onCleanFilterHandled={() => setCleanFilters(false)} onOpenFilterHandled={() => setOpenFilters(false)} />
              )}
            </div>
          }
        />
      ) : (
        <Navigate to="/login" />
      )}
    </>
  );
}

export default BudgetList;




